// export let pluginConfig = {
//   lang: 'en',
//   position: 'bottom-right',
//   offset: [20, 20],
//   size: 58
// };

import type { IconItem, WidgetConfig } from "../types/widget";
import { Accessibility, Eye, Settings, Palette } from "lucide-react";

export const ICON_LIBRARY: IconItem[] = [
  { id: "accessibility", icon: Accessibility, name: "Accessibility" },
  { id: "eye", icon: Eye, name: "Eye" },
  { id: "settings", icon: Settings, name: "Settings" },
  { id: "palette", icon: Palette, name: "Palette" },
];

export const POSITION_OPTIONS = [
  { value: "top-left", label: "Top Left" },
  { value: "top-right", label: "Top Right" },
  { value: "bottom-left", label: "Bottom Left" },
  { value: "bottom-right", label: "Bottom Right" },
];

export const TEXT_ALIGNMENT_OPTIONS = [
  { value: "left", label: "Left" },
  { value: "center", label: "Center" },
  { value: "right", label: "Right" },
];

export const defaultConfig: WidgetConfig = {
  status: {
    mobile: true,
    desktop: true,
  },
  iconId: "default",
  iconSize: 48,
  label: "Accessibility widget",
  heading: "Accessibility menu",
  position: {
    mobile: "bottom-right",
    desktop: "bottom-right",
  },
  language: {
    default: "en",
    selected: [],
  },
  margins: {
    desktop: {
      top: 20,
      bottom: 20,
      left: 20,
      right: 20,    
    },
    mobile: {
      top: 20,
      bottom: 20,
      left: 20,
      right: 20,
    },
  },
  primaryColor: "#1863DC",
  keyboard: {
    enabled: false,
    shortcut: 'alt+a',
  },
  modules: {
    color: {
      darkContrast: { enabled: true },
      lightContrast: { enabled: true },
      highContrast: { enabled: true },
      highSaturation: { enabled: true },
      lowSaturation: { enabled: true },
      monochrome: { enabled: true },
    },
    content: {
      adjustFontSizing: { enabled: true },
      highlightTitle: { enabled: true },
      highlightLinks: { enabled: true },
      dyslexicFont: { enabled: true },
      letterSpacing: { enabled: true },
      lineHeight: { enabled: true },
      fontWeight: { enabled: true },
      alignLeft: { enabled: true },
    },
    navigation: {
      readingGuide: { enabled: true },
      pauseAnimations: { enabled: true },
      bigCursor: { enabled: true },
    },
    statement: {
      enabled: false,
      url: "",
    },
  },
};

declare global {
  interface Window {
    _cyA11yConfig?: WidgetConfig;
  }
}

const _remote = window._cyA11yConfig;
export const pluginConfig: WidgetConfig = {
  ...defaultConfig,
  ..._remote,
  keyboard: {
    ...defaultConfig.keyboard,
    ...(_remote?.keyboard || {}),
  },
  modules: {
    color: {
      ...defaultConfig.modules.color,
      ...(_remote?.modules?.color || {}),
    },
    content: {
      ...defaultConfig.modules.content,
      ...(_remote?.modules?.content || {}),
    },
    navigation: {
      ...defaultConfig.modules.navigation,
      ...(_remote?.modules?.navigation || {}),
    },
    statement: {
      ...defaultConfig.modules.statement,
      ...(_remote?.modules?.statement || {}),
    },
  },
};